module.exports = __webpack_public_path__ + "static/media/back2.7cb0c662.jpg";